<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter19">
<h1><a id="page_37"></a><a href="#/003toc#ch19">Monterey Bay Bean Soup</a></h1>
<p class="noindent">This is a favorite soup with my students. It goes together in 5 minutes, and at the end of the day you have a hearty vegetarian main course. Don’t let the chiles scare you away; they are there for flavor and not heat!</p>
<p class="noindent"><sup>1</sup>/<sub>3</sub> cup vegetable oil</p>
<p class="noindent">1 large onion, finely chopped</p>
<p class="noindent">1 clove garlic, minced</p>
<p class="noindent">4 Anaheim chiles, seeded and chopped</p>
<p class="noindent">1½ teaspoons chili powder</p>
<p class="noindent">One 14- to 15-ounce can chopped tomatoes, drained</p>
<p class="noindent">Two 14- to 15-ounce cans pinto beans, drained and rinsed</p>
<p class="noindent">6 cups chicken broth</p>
<p class="noindent">2 cups cooked chorizo sausage, crumbled (optional)</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">2 cups broken fried tortilla strips</p>
<p class="noindent">½ cup shredded mild Cheddar or Monterey</p>
<p class="noindent">Jack cheese</p>
<p class="noindent">½ cup sour cream for garnishing</p>
<p class="noindent">4 green onions, chopped, using the white and tender green parts for garnishing</p>
<p class="noindent">½ cup finely minced fresh cilantro for garnishing</p>
<p class="noindent">heat the oil in a large skillet over medium heat. Add the onion, garlic, and chiles and sauté until the vegetables are softened, about 5 minutes. Stir in the chili powder and cook, stirring, for about 1 minute, until fragrant.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the tomatoes, beans, broth, and sausage (if using).</p>
<p class="noindent">cover the slow cooker and cook the soup on high for 3 to 4 hours or on low for 7 to 8 hours.</p>
<p class="noindent">season with salt and pepper. Add the tortilla strips to the soup, cover, and let stand for 10 minutes, until the strips just begin to soften.</p>
<p class="noindent">divide the cheese among 8 bowls and ladle the soup over.</p>
<p class="noindent">Garnish each serving with a dollop of sour cream, chopped green onion, and minced cilantro.</p>
<p class="noindent">serves 8</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 025-chapter19.vue?7d1888a3